var has = Object.prototype.hasOwnProperty;
// Object.hasOwn, which IE 11 lacks
export default function hasOwn(object, key) {
  return has.call(object, key);
}